module.exports = __webpack_public_path__ + "img/RUS.adc97ad7.svg";